<template>
	<grid>
		<grid-group :title="$t('Today')" v-if="hasDataAlertsToday">
			<grid-item-warning v-for="item in getAlertsToday" :key="item.id" :title="`${ getDateHuman(item.create_time) } | ${ getPatient(item.args.virtual_watch).name }`" :src="getPatient(item.args.virtual_watch).picture" :value="item.title">
				<action-group>
					<action-group-item-button @click="goToPatient(item)" :title="$t('Go to paticient')" />
				</action-group>
			</grid-item-warning>
		</grid-group>
		<grid-group :title="$t('Previous')" v-if="hasDataAlertsAfterToday">
			<grid-item-warning v-for="item in getAlertsAfterToday" :key="item.id" :title="`${ getDateHuman(item.create_time) } | ${ getPatient(item.args.virtual_watch).name }`" :src="getPatient(item.args.virtual_watch).picture" :value="item.title">
				<action-group>
					<action-group-item-button @click="goToPatient(item)" :title="$t('Go to paticient')" />
				</action-group>
			</grid-item-warning>
		</grid-group>
		<grid-empty :showWhen="!hasDataAlertsToday && !hasDataAlertsAfterToday" :message="$t('No alerts yet.')" />
	</grid>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import Grid from '@/modules/ui/Grid'
import GridEmpty from '@/modules/ui/GridEmpty'
import GridItemWarning from '@/modules/ui/GridItemWarning'
import GridGroup from '@/modules/ui/GridGroup'
import ActionButton from '@/modules/ui/ActionButton'
import ActionGroup from '@/modules/ui/ActionGroup'
import ActionGroupItemButton from '@/modules/ui/ActionGroupItemButton'
export default {
	components: {
		Grid,
		GridEmpty,
		GridItemWarning,
		GridGroup,
		ActionButton,
		ActionGroup,
		ActionGroupItemButton
	},
	props: [
		'user_uid'
	],
	computed: {
		hasDataAlertsToday() {
			return this.getAlertsToday.length > 0
		},
		hasDataAlertsAfterToday() {
			return this.getAlertsAfterToday.length > 0
		},
		getAlertsToday() {
			return this.getAlerts(this.currentUser).filter(item => moment().isSame(item.create_time, 'day'))
		},
		getAlertsAfterToday() {
			return this.getAlerts(this.currentUser).filter(item => !moment().isSame(item.create_time, 'day'))
		},
		...mapGetters({
			currentUser: 'CURRENT_USER',
			getAlerts: 'WARNINGS_READ',
			getPatient: 'PATIENT_BY_ID'
		})
	},
	methods: {
		goToPatient(item) {
			const patient = this.getPatient(item.args.virtual_watch)
			this.$router.push({
				name: 'WatchDashboard',
				params: {
					user_uid: this.currentUser.uid,
					watch_id: patient.id
				}
			})
		},
		getDateHuman(datetime) {
			return moment(datetime).fromNow()
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/user/alerts/UserAlertsRead.vue